import Repository from './repository'

const resource = '/payment-forms'

export default {
  // AlunoGetById (id) {
  //   return Repository.get(`${resource}/${id}`)
  // },
  FormaGet () {
    return Repository.get(`${resource}`)
  },
  // AlunoPost (item) {
  //   return Repository.post(`${resource}`, item)
  // },
  // AlunoPut (id, item) {
  //   return Repository.put(`${resource}/${id}`, item)
  // },
  // AlunoDelete (planoId) {
  //   return Repository.delete(`${resource}/${planoId}`)
  // }
}
